import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import get from "lodash/get";
import Modal from "src/features/Components/Modal";
import PropTypes from "prop-types";
import Radio from "@material-ui/core/Radio";
import React, { useState, useEffect } from "react";

// import { useTheme } from "@material-ui/core/styles";
// import IconButton from '@material-ui/core/IconButton'
// import Button from '@material-ui/core/Button'
// import Icon from '@material-ui/core/Icon'
// import Grid from '@material-ui/core/Grid'
function MyModal(props) {
  // const theme = useTheme()
  const [tempSelect, setTempSelected] = useState({});

  useEffect(() => {
    if (get(props, "selected._id")) {
      setTempSelected(props.selected);
    }
  }, [props, props.selected]);

  return (
    <Modal
      maxWidth="lg"
      isOpen={props.open}
      handleClose={props.handleCloseModal}
      title={
        <strong>
          {props.type === "address"
            ? "ข้อมูลการจัดส่ง"
            : "ข้อมูลออกใบกำกับภาษี"}
        </strong>
      }
      cancelText="ยกเลิก"
      okText="บันทึก"
      onOk={() => {
        // send _id back
        props.onSubmit(tempSelect._id);
        props.handleCloseModal();
      }}
    >
      {props.address_book.map((item, index) => (
        <div key={item._id}>
          <Box display="flex" mb={1} mt={1} alignItems="center">
            <Box mr={2}>
              <Radio
                color="primary"
                checked={get(tempSelect, "_id") === item._id}
                onClick={() => setTempSelected(item)}
              />
            </Box>
            <Box>
              <Box fontSize="12px" color="text.secondary">
                ADDRESS {index + 1}
              </Box>
              {`${item.line1}, ${item.sub_district}, ${item.district}, ${item.province}, ${item.postal_code}`}
            </Box>
          </Box>
          <Divider />
        </div>
      ))}
    </Modal>
  );
}

MyModal.propTypes = {
  address_book: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  selected: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["address", "tax"]).isRequired,
};

export default MyModal;
